// extracted by mini-css-extract-plugin
export default {"attCheckVerified":"AttendanceOverviewExternshipTab_attCheckVerified__DgR-B","rightFilter":"AttendanceOverviewExternshipTab_rightFilter__urnaT"};